import React, { useState } from "react";
import career from "../../assest/career.jpg";
import "./AboutCareer2.css";
import distributorIcon from "../../assest/Icon/rocket (1).png";  

const AboutCareer2 = () => {
  const [openBox, setOpenBox] = useState(null);  

  const toggleBox = (boxNumber) => {
    setOpenBox((prevBox) => (prevBox === boxNumber ? null : boxNumber));  
  };

  return (
    <div className="about-container3">
      <h2 className="about-header2">Career</h2>
      <p className="about-description">
        If you are interested in joining our company, please send your resume to{" "}
        <a href="mailto:sales@proscope.co.th" className="email-link">
          sales@proscope.co.th
        </a>
        .
      </p>
      <div className="image-container">
        <img src={career} alt="Career Opportunities" className="career-image" />
      </div>
      <p className="about-text">
        Technology is shifting rapidly, and so is the business paradigm. We
        believe that knowledge is the key to success for our employees.
      </p>
      <p className="about-text">
        We are looking for energetic, adaptive, quick-learning, open-minded
        individuals who dare to speak up for the right thing. We will strive to
        build a warm working environment, and{" "}
        <strong>
          we will not sell this company to any investor or in any stock market
          in the future
        </strong>
        .
      </p>

      {/* กล่องที่ 1 */}
      <div className="job-listing-container">
        <div className="job-box">
          <div className="job-title-container">
            <img
              src={distributorIcon}
              alt="Distributor Icon"
              className="icon2"
            />
            <h3 className="job-title" onClick={() => toggleBox(1)}>
              Relation Sales Executive
              <span className={`toggle-arrow ${openBox === 1 ? "open" : ""}`}>
                {openBox === 1 ? "▲" : "▼"}
              </span>
            </h3>
          </div>
          {openBox === 1 && (
            <div className="job-details">
              <div className="job-section">
                <h4 className="job-subtitle">Qualifications</h4>
                <ul className="job-list">
                  <li>- Male or Female, 22-30 years of age.</li>
                  <li>
                    - Bachelor degree in Marketing, Business Administration,
                    Computer Science, Computer Engineer, or any related fields.
                  </li>
                  <li>
                    - Really want to be sales. Love to sales. Love to meet and
                    talk with people. Love to make connection.
                  </li>
                  <li>- No experience required.</li>
                  <li>
                    - Computer literacy. Can use MS Word, MS Excel, MS
                    PowerPoint.
                  </li>
                  <li>- Have disciplined</li>
                  <li>
                    - Good command of spoken and written English language is
                    preferred.
                  </li>
                  <li>
                    - Good presentation skill. Can present to people up to 10
                    people in one room.
                  </li>
                </ul>
              </div>
              <div className="job-section">
                <h4 className="job-subtitle">Responsibilities</h4>
                <ul className="job-list">
                  <li>- Build new customer database in focus segment.</li>
                  <li>
                    - Contact customer in your database and select focus account
                    to make relationships and maintain revenue from customers.
                  </li>
                  <li>
                    - Coordinate with customers, partners, and internal teams to
                    prepare proposals and present solutions to customers.
                  </li>
                  <li>- Closing sales & manage until payment is done.</li>
                  <li>- Must achieve individual sales targets.</li>
                  <li>
                    - Creating Sales documents for customers such as quotations
                    and Sales Orders.
                  </li>
                  <li>
                    - Develop account plans and sales strategies to maximize
                    business opportunities.
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* กล่องที่ 2 */}
      <div className="job-listing-container">
        <div className="job-box">
          <div className="job-title-container">
            <img
              src={distributorIcon}
              alt="Distributor Icon"
              className="icon2"
            />
            <h3 className="job-title" onClick={() => toggleBox(2)}>
              Advanced Technology Engineer
              <span className={`toggle-arrow ${openBox === 2 ? "open" : ""}`}>
                {openBox === 2 ? "▲" : "▼"}
              </span>
            </h3>
          </div>
          {openBox === 2 && (
            <div className="job-details">
              <div className="job-section">
                <h4 className="job-subtitle">Qualifications</h4>
                <ul className="job-list">
                  <li>- Male or Female, 22-30 years of age.</li>
                  <li>
                    - Bachelor degree in Computer Science or Computer Engineer.
                  </li>
                  <li>
                  - Love Technology, like to try new thing, dig the curiousness until know the root.

                  </li>
                  <li>
                  - Team working oriented, fast learner, like to explore new technology, and proactive.
                  </li>
                  <li>- Advanced computer skills. Good writing skills.</li>
                  <li>- Must have disciplined.</li>
                  <li>
                    - Good command of spoken and written English language is
                    preferred.
                  </li>
                  <li>
                    - We want to invest in your skill development if you are the
                    right one.
                  </li>
                </ul>
              </div>
              <div className="job-section">
                <h4 className="job-subtitle">Responsibilities</h4>
                <ul className="job-list">
                  <li>- Perform project configuration and implementation, testing, integration and migration.
                  </li>
                  <li>
                  - Deliver and implement projects following customer’s technical requirement as agreed in the technical proposals.
                  </li>
                  <li>- Can handle multiple projects at any time.
                  </li>
                  <li>
                  - Provide Level 1 and 2 IT system fault investigation, troubleshooting, resolution and preventive maintenance for customer’s systems when required.
                  </li>
                  <li>- Study and evaluate IT solutions that best fit corporate requirement with timely and good professional quality as well as align with business requirement.
                  </li>
                  <li>- Write the setup and configuration after finish the job.
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* กล่องที่ 3 */}
      <div className="job-listing-container">
        <div className="job-box">
          <div className="job-title-container">
            <img
              src={distributorIcon}
              alt="Distributor Icon"
              className="icon2"
            />
            <h3 className="job-title" onClick={() => toggleBox(3)}>
              Programmer
              <span className={`toggle-arrow ${openBox === 3 ? "open" : ""}`}>
                {openBox === 3 ? "▲" : "▼"}
              </span>
            </h3>
          </div>
          {openBox === 3 && (
            <div className="job-details">
              <div className="job-section">
                <h4 className="job-subtitle">Qualifications</h4>
                <ul className="job-list">
                  <li>- Male or Female, 22-30 years of age.</li>
                  <li>
                    - Bachelor degree in Computer Science or Computer Engineer.
                  </li>
                  <li>
                  - Love programming, like to try new thing, dig the curiousness until know the root.

                  </li>
                  <li>
                  - Team working oriented, fast learner, like to explore new technology, and proactive.

                  </li>
                  <li>- Advanced computer skills. Good writing skills.</li>
                  <li>- Must be disciplined.</li>
                  <li>
                    - Knowledge in technologies such as Java (preferred), .Net,
                    C, VB, web applications, PHP, etc.
                  </li>
                  <li>
                    - Good command of spoken and written English language is
                    preferred.
                  </li>
                  <li>
                    - We want to invest in your skill development if you are the
                    right one.
                  </li>
                </ul>
              </div>
              <div className="job-section">
                <h4 className="job-subtitle">Responsibilities</h4>
                <ul className="job-list">
                  <li>- Get requirement from customer.</li>
                  <li>- Create mockup and present to customer.</li>
                  <li>
                    - Estimate and plan delivery time for overall project.
                  </li>
                  <li>- Must be able to deliver project in time.</li>
                  <li>
                    - Write the setup and configuration after finish the job.
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AboutCareer2;
